import {
  Drawer,
  DrawerProps,
  FormProps,
  ButtonProps,
  Grid,
  Create
} from '@pankod/refine-antd'
import { ChildCategoryForm } from './form'

type CreateChildCategoryProps = {
    drawerProps: DrawerProps;
    formProps: FormProps;
    saveButtonProps: ButtonProps;
};

export const CreateChildCategory: React.FC<CreateChildCategoryProps> = ({
  drawerProps,
  formProps,
  saveButtonProps
}) => {
  const breakpoint = Grid.useBreakpoint()

  return (
    <Drawer
      {...drawerProps}
      width={breakpoint.sm ? '800px' : '100%'}
      bodyStyle={{ padding: 0 }}
      zIndex={1001}
    >
      <Create
        saveButtonProps={saveButtonProps}
        pageHeaderProps={{ extra: null }}
        resource='marketplace_categories'
      >
        <ChildCategoryForm formProps={formProps} />
      </Create>
    </Drawer>
  )
}
